import { render } from "./SimpleNoteDetailTabsPanel.vue?vue&type=template&id=f48e8520"
import script from "./SimpleNoteDetailTabsPanel.vue?vue&type=script&lang=js"
export * from "./SimpleNoteDetailTabsPanel.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__